import { default as _ } from './index';

// @ts-ignore
export = _
